import { Injectable, Signal } from '@angular/core';

import { Dispatch } from '@ngxs-labs/dispatch-decorator';
import { Store } from '@ngxs/store';

import { Alternative } from '../../models';
import { AlternativeActions } from './alternative.actions';
import { AlternativeSelectors } from './alternative.selectors';

@Injectable({
  providedIn: 'root',
})
export class AlternativeFacade {
  selectedAlternativeUuid$ = this.store.select(AlternativeSelectors.getSelectedAlternativeUuid);
  selectedAlternativeUnits$ = this.store.select(AlternativeSelectors.getSelectedAlternativeUnits);
  selectedAlternativeDeletedUnits$ = this.store.select(AlternativeSelectors.getSelectedAlternativeDeletedUnits);
  selectedAlternative = this.store.selectSignal(AlternativeSelectors.getSelectedAlternative) as Signal<
    Alternative | undefined
  >;

  constructor(private readonly store: Store) {}

  get selectedAlternativeUuid() {
    return this.store.selectSnapshot(AlternativeSelectors.getSelectedAlternativeUuid);
  }

  getSelectedAlternativeUnitSnapshot(unitId: string) {
    return this.store.selectSnapshot(AlternativeSelectors.getSelectedAlternativeUnit(unitId));
  }

  getSelectedAlternativeUnitAsSignal(unitId: string) {
    return this.store.selectSignal(AlternativeSelectors.getSelectedAlternativeUnit(unitId));
  }

  getAlternativeUnit(alternativeId: string, unitId: string) {
    return this.store.selectSnapshot(AlternativeSelectors.getAlternativeUnit(alternativeId, unitId));
  }

  getSelectedAlternativeUnit$(unitId: string) {
    return this.store.select(AlternativeSelectors.getSelectedAlternativeUnit(unitId));
  }

  @Dispatch()
  setSelectedAlternativeUuid(alternativeUuid: string | null) {
    return new AlternativeActions.SetSelected(alternativeUuid);
  }

  @Dispatch()
  confirmQuoteAlternative(projectId: string, selectionId: string, alternativeId: string) {
    return new AlternativeActions.Confirm(projectId, selectionId, alternativeId);
  }
}
